import { useEffect, useRef } from "react";

import { isDefined } from "Utils/functions";
import { useFormikContext } from "formik";

export const ScrollToFirstError = (): null => {
  const previousCount = useRef<number>();
  const formikContexts = useFormikContext();

  const { submitCount, errors } = formikContexts;

  useEffect(() => {
    if (previousCount.current === submitCount || submitCount === 0) {
      return;
    }

    previousCount.current = submitCount;

    const keys = Object.keys(errors);

    if (keys.length === 0) {
      return;
    }

    const names = keys.map((key) => `#${key},[name="${key}"]`);
    const query = names.join(",");
    const element = document.querySelector<
      HTMLInputElement | HTMLSelectElement
    >(query);

    if (isDefined(element)) {
      element.scrollIntoView({ behavior: "smooth" });
      element.focus();
    }
  }, [previousCount, submitCount, errors]);

  return null;
};
